export default __webpack_public_path__ + "static/media/cryptoDonation.ab63ef2d.jpg";